export const contactsData = {
    email: 'anasszerhoun2020@gmail.com',
    phone: '+212623466715',
    sheetAPI: ''
}